import { checkColor } from '@app/utils';
import { StyleSheet, Platform } from 'react-native';
const ls = StyleSheet.create({
  flatListContainer: {
    marginLeft: 16,
  },
  image: {
    width: 208,
    height: 77,
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
  },
  iconContainer: {
    paddingLeft: 15,
    marginBottom: -20,
    zIndex: 1,
  },
  textContainer: {
    marginTop: 15,
    paddingLeft: 16,
    paddingRight: 9,
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
  },
  urlContainer: {
    marginTop: 6,
    paddingLeft: 15,
    paddingBottom: 16,
  },
  urlText: {
    fontSize: 12,
    fontWeight: '600',
    fontFamily: 'Inter',
    color: checkColor('#1434CB'),
    lineHeight: 18,
  },
});

export default ls;
